export const Type={
    ADD_TO_BASKET:'ADD_TO_BASKET',
    REMOVE_FROM_BASKET:  "REMOVE_FROM_BASKET",
    SET_USER:"SET_USER",
    EMPTY_BASKET:"EMPTY_BASKET"

}